import React from 'react';
import { Route, Navigate, Routes } from "react-router-dom";
import { CRUDRootTable } from './CRUDRootTable';

export const CRUDRootRoute = ({ auth, model }) => {    
    const { root } = model;
    return auth === true ? (
        <Routes>
            <Route path={`/${root}`} element={<CRUDRootTable model={model} />} />
        </Routes>        
    ) : (
        <Routes>
            <Route element={
                <Navigate to='/' />
            } />
        </Routes>
        
    );
}